export const neasc = {
  title: "Acreditación Internacional NEASC",
  subtitle: "Gándara International School está acreditado por la New England Association of Schools and Colleges (NEASC), una de las organizaciones de acreditación educativa más prestigiosas del mundo.",
  badge: "Escuela Acreditada NEASC",
  learnMore: "Conoce más sobre NEASC",
  learnMoreUrl: "https://www.neasc.org",
  benefits: {
    quality: {
      title: "Garantía de Calidad",
      description: "Verificación externa e independiente de que cumplimos con los más altos estándares educativos internacionales."
    },
    recognition: {
      title: "Reconocimiento Global",
      description: "Nuestros diplomas y certificados son reconocidos por instituciones educativas en todo el mundo."
    },
    improvement: {
      title: "Mejora Continua",
      description: "Compromiso permanente con la evaluación y mejora de nuestros programas, instalaciones y metodologías."
    },
    transferability: {
      title: "Transferibilidad",
      description: "Facilita la transición de estudiantes hacia otras escuelas acreditadas en España y el extranjero."
    }
  }
};
